import { render, staticRenderFns } from "./PanelsGroupList.vue?vue&type=template&id=7344f232&"
import script from "./PanelsGroupList.vue?vue&type=script&lang=js&"
export * from "./PanelsGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports